// This is verified solution on StackOverflow: https://stackoverflow.com/a/33956608
export class BlendModeChecker {
  private ctx1: CanvasRenderingContext2D;
  private c1: HTMLCanvasElement;
  private ctx2: CanvasRenderingContext2D;
  private c2: HTMLCanvasElement;
  private ctx3: CanvasRenderingContext2D;
  private c3: HTMLCanvasElement;
  private pos: number[];
  private em: number[];
  private d1: Uint8ClampedArray;
  private d2: Uint8ClampedArray;
  private static blendModeDefinition: { [key: string]: number[] } = {
    "destination-out": [0, 1, 0]
  };

  constructor() {
    this.c1 = document.createElement("canvas");
    this.c1.width = this.c1.height = 3;
    this.c2 = this.c1.cloneNode(true) as HTMLCanvasElement;
    this.c3 = this.c1.cloneNode(true) as HTMLCanvasElement;

    this.ctx1 = this.c1.getContext("2d") as CanvasRenderingContext2D;
    this.ctx2 = this.c2.getContext("2d") as CanvasRenderingContext2D;
    this.ctx3 = this.c3.getContext("2d") as CanvasRenderingContext2D;

    this.ctx1.fillStyle = "green";
    this.ctx1.fillRect(0, 0, 3, 3);
    this.ctx2.fillStyle = "pink";
    this.ctx2.fillRect(0, 0, 3, 3);

    this.em = [0, 0, 0, 0];
    this.d1 = this.ctx1.getImageData(0, 0, 1, 1).data;
    this.d2 = this.ctx2.getImageData(0, 0, 1, 1).data;

    this.pos = [16, 0, 32];
  }

  testMode(mode: any): boolean {
    return false;
    let i;
    // get the array corresponding to the actual key
    const arr = BlendModeChecker.blendModeDefinition[mode];

    const layer = [];
    // get the correct imageData for each layer we should find
    for (i = 0; i < 3; i++) {
      switch (arr[i]) {
        case 0:
          layer[i] = this.em;
          break;
        case 1:
          layer[i] = this.d1;
          break;
        case 2:
          layer[i] = this.d2;
          break;
        case 3:
          layer[i] = null;
          break;
      }
    }
    // first reset the canvas
    this.ctx3.globalCompositeOperation = "source-over";
    this.ctx3.clearRect(0, 0, 3, 3);
    // draw the first layer in the top-left corner
    this.ctx3.drawImage(this.c1, -1, -1);
    // set the current blend mode
    this.ctx3.globalCompositeOperation = mode;
    // draw the second layer in the top-right corner so it comes over it
    this.ctx3.drawImage(this.c2, 1, 1);
    // get the image data of our test canvas
    const d3 = this.ctx3.getImageData(0, 0, 3, 3).data;
    // we will first admit that it is supported;
    let tempResult = true;
    // iterate through the 3 positions (center, top-left, bottom-right)
    for (i = 0; i < this.pos.length; i++) {
      // we know what it should return
      const layerFirstDimension = layer[i];
      if (layerFirstDimension !== null) {
        // is it the same pixel as expected ?
        tempResult =
          d3[this.pos[i]] === layerFirstDimension[0] &&
          d3[this.pos[i] + 1] === layerFirstDimension[1] &&
          d3[this.pos[i] + 2] === layerFirstDimension[2] &&
          d3[this.pos[i] + 3] === layerFirstDimension[3];
      }
      // some blending operation
      else {
        // is it different than the last drawn layer ?
        //(if the mode is not supported, the default blend mode "source-over" will be used)
        tempResult =
          d3[this.pos[i]] !== this.d2[0] ||
          d3[this.pos[i] + 1] !== this.d2[1] ||
          d3[this.pos[i] + 2] !== this.d2[2] ||
          d3[this.pos[i] + 3] !== this.d2[3];
      }
      // our flag switched to false
      if (!tempResult)
        // no need to go to the other pixels, it's not supported
        return false;
    }
    // this mode is supported
    return true;
  }
}
